import React, { Dispatch, FC, SetStateAction } from 'react';
import s from './summary.module.scss';
import { Button } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
import { LinksEnum } from '@specs/navigation';
import { defaultState, StateType } from '@components/Pages/PaymentsPages/Withdraw/Form/Form';
import { minRubyWithdrawAmount } from '@specs/constants';
import { formatNumber } from '@helpers/arToysHelpers';
import { api } from '@api';
import { useInvalidate } from '@hooks/TRPC_Hooks/useInvalidate';
import { useShowToast } from '@hooks/useShowToast';
import { KYCType } from '@services/payments/model';
interface Props {
  formState: StateType;
  kycStatus: KYCType;
  setFormState: Dispatch<SetStateAction<StateType>>;
}
export const Summary: FC<Props> = ({
  formState,
  kycStatus,
  setFormState
}) => {
  const {
    showToast
  } = useShowToast();
  const {
    translate: tr
  } = useTranslation();
  const utils = api.useUtils();
  const {
    updateProfileData
  } = useInvalidate();
  const {
    mutateAsync
  } = api.PayoutManager.create.useMutation({
    mutationKey: ['PayoutManager.create'],
    onError: () => {
      showToast({
        variant: 'error',
        text: 'error.default'
      });
    },
    onSuccess: async data => {
      if (data.status === 'reject') {
        showToast({
          variant: 'error',
          text: data.code
        });
        return;
      }
      showToast({
        variant: 'success'
      });
      await updateProfileData();
      await utils.PayoutManager.getPayouts.invalidate();
      setFormState(defaultState);
    }
  });
  const sendRequestHandler = async () => {
    if (!isValidForm || typeof formState.price !== 'number') return;
    await mutateAsync({
      ...formState,
      price: formState.price * 100
    });
  };
  const supportHandler = () => {
    window.open(LinksEnum.SUPPORT, '_blank', 'noreferrer');
  };
  const isValidForm = kycStatus === 'completed' && typeof formState.price === 'number' && formState.price >= minRubyWithdrawAmount && !!formState.country && !!formState.holderName && !!formState.bankName && !!formState.accountNumber && !!formState.swiftCode && !!formState.iban;
  return <div className={s.summary} data-sentry-component="Summary" data-sentry-source-file="Summary.tsx">
            <div className={s.summary__main}>
                <div className={s.summary__total}>
                    {tr({
          id: 'withdraw.page.summary.title'
        })}
                </div>
                <div className={s.summary__amount}>
                    ${formatNumber(Number(formState.price) * 100)}
                </div>
            </div>
            <div className={s.summary__footer}>
                <Button id='withdraw_page_send_request_button' size={'large'} color={'Black'} onClick={sendRequestHandler} disabled={!isValidForm} data-sentry-element="Button" data-sentry-source-file="Summary.tsx">
                    {tr({
          id: 'btn.send.request'
        })}
                </Button>
                <Button id='withdraw_page_support_button' size={'medium'} color={'Transparent'} onClick={supportHandler} data-sentry-element="Button" data-sentry-source-file="Summary.tsx">
                    {tr({
          id: 'withdraw.page.summary.support'
        })}
                </Button>
            </div>
        </div>;
};